import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import '../styles/navbar.css';
import '../styles/sidebar.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await api.post('/auth/forgot-password', { email });
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Header matching Login.tsx */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1040,
        backgroundColor: '#4D64C1',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        height: '70px'
      }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 20px',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <a href="https://purehd.com" target="_blank" rel="noopener noreferrer">
            <img
              src="/img/PureHD_Logo.png"
              alt="PureHD Logo"
              style={{
                height: '45px',
                width: 'auto',
                display: 'block',
                filter: 'brightness(0) invert(1)',
                objectFit: 'contain'
              }}
            />
          </a>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '30px'
          }}>
            <div style={{
              color: 'white',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <i className="fas fa-phone-alt" style={{ fontSize: '13px', opacity: 0.9 }}></i>
              <span>Questions? Call</span>
              <span style={{ fontWeight: '600' }}>(888) 787-3431</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{
        minHeight: '100vh',
        paddingTop: '70px',
        backgroundColor: '#f8f9fa',
        display: 'flex',
        alignItems: 'center'
      }}>
        <div className="container" style={{ padding: '40px 15px' }}>
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-8 col-xl-5">
              <div className="mx-auto" style={{ maxWidth: '440px' }}>

                {!success ? (
                  <div className="card" style={{
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                    border: 'none',
                    borderRadius: '12px',
                    overflow: 'hidden'
                  }}>
                    <div style={{
                      backgroundColor: '#4D64C1',
                      color: 'white',
                      padding: '25px',
                      textAlign: 'center'
                    }}>
                      <i className="fas fa-key" style={{ fontSize: '40px', marginBottom: '10px', opacity: 0.9 }}></i>
                      <h1 style={{ fontSize: '22px', margin: 0, fontWeight: '600' }}>Reset Your Password</h1>
                    </div>
                    <div className="card-body" style={{ padding: '35px 30px' }}>

                      <p style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        marginBottom: '25px',
                        textAlign: 'center'
                      }}>
                        Enter your email address and we'll send you a link to reset your password.
                      </p>

                      {error && (
                        <div className="alert alert-danger d-flex align-items-center">
                          <i className="fas fa-times-circle flex-shrink-0 me-3"></i>
                          <div>{error}</div>
                        </div>
                      )}

                      <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                          <label htmlFor="email" className="form-label" style={{ fontWeight: '500', color: '#2c3e50', marginBottom: '8px' }}>
                            Email Address
                          </label>
                          <div className="input-group">
                            <span className="input-group-text" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
                              <i className="fas fa-envelope" style={{ color: '#4D64C1' }}></i>
                            </span>
                            <input
                              type="email"
                              id="email"
                              name="email"
                              className="form-control"
                              required
                              autoFocus
                              placeholder="you@example.com"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              disabled={loading}
                              style={{ borderLeft: 'none' }}
                            />
                          </div>
                        </div>

                        <div className="d-grid mb-3">
                          <button
                            className="btn btn-primary btn-lg"
                            type="submit"
                            disabled={loading}
                            style={{
                              backgroundColor: loading ? '#cccccc' : '#4D64C1',
                              border: 'none',
                              padding: '12px',
                              fontSize: '16px',
                              fontWeight: '500',
                              borderRadius: '8px',
                              transition: 'all 0.3s ease',
                              cursor: loading ? 'not-allowed' : 'pointer'
                            }}
                          >
                            {loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Sending...
                              </>
                            ) : (
                              <>
                                <i className="fas fa-paper-plane me-2"></i> Send Reset Link
                              </>
                            )}
                          </button>
                        </div>

                        <div style={{ textAlign: 'center' }}>
                          <Link
                            to="/login"
                            style={{
                              color: '#4D64C1',
                              textDecoration: 'none',
                              fontSize: '14px',
                              fontWeight: '500'
                            }}
                          >
                            <i className="fas fa-arrow-left me-2"></i>
                            Back to Login
                          </Link>
                        </div>
                      </form>
                    </div>
                  </div>
                ) : (
                  <div className="card" style={{
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                    border: 'none',
                    borderRadius: '12px',
                    overflow: 'hidden'
                  }}>
                    <div style={{
                      backgroundColor: '#28a745',
                      color: 'white',
                      padding: '25px',
                      textAlign: 'center'
                    }}>
                      <i className="fas fa-check-circle" style={{ fontSize: '40px', marginBottom: '10px', opacity: 0.9 }}></i>
                      <h1 style={{ fontSize: '22px', margin: 0, fontWeight: '600' }}>Check Your Email</h1>
                    </div>
                    <div className="card-body" style={{ padding: '35px 30px', textAlign: 'center' }}>
                      <p style={{ fontSize: '15px', color: '#2c3e50', marginBottom: '20px' }}>
                        If an account exists for <strong>{email}</strong>, you will receive a password reset link shortly.
                      </p>
                      <p style={{ fontSize: '14px', color: '#6c757d', marginBottom: '25px' }}>
                        Please check your email and click the link to reset your password. The link will expire in 24 hours.
                      </p>
                      <div className="alert alert-info" style={{ textAlign: 'left' }}>
                        <i className="fas fa-info-circle me-2"></i>
                        If you don't receive an email within a few minutes, please check your spam folder.
                      </div>
                      <Link
                        to="/login"
                        className="btn btn-primary"
                        style={{
                          backgroundColor: '#4D64C1',
                          border: 'none',
                          padding: '12px 30px',
                          fontSize: '16px',
                          fontWeight: '500',
                          borderRadius: '8px'
                        }}
                      >
                        <i className="fas fa-arrow-left me-2"></i>
                        Return to Login
                      </Link>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
